import { render, staticRenderFns } from "./BannerLayout.vue?vue&type=template&id=f4e7b3a2&scoped=true&"
import script from "./BannerLayout.vue?vue&type=script&lang=js&"
export * from "./BannerLayout.vue?vue&type=script&lang=js&"
import style0 from "./BannerLayout.vue?vue&type=style&index=0&id=f4e7b3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e7b3a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBanner,VBtn,VCol,VDivider,VRow})
